import React from "react";
import { Link } from "react-router-dom";
import SectionHeader from "./SectionHeader";
import ScrollCarousel from "./ScrollCarousel";
import { COLLECTIONS } from "../mock";

// "Explore Our Travel Collections" — fixed-width (160px) brand/collection logo
// cards in a native scroll-snap track (clamps cleanly at both ends).
export default function TravelCollections() {
  return (
    <section className="v2-section" id="travel-collections-v2">
      <SectionHeader title="Explore Our Travel Collections" subtitle="Find holidays tailored to every travel style." viewAllHref="/web" />
      <ScrollCarousel trackClassName="v2-collections__track" step={352}>
        {COLLECTIONS.map((c) => (
          <Link to={c.href} className="v2-collection-card" key={c.id}>
            <div className="v2-collection-card__logo">
              <img src={c.logo} alt={c.name} />
            </div>
            <span className="v2-collection-card__name">{c.name}</span>
          </Link>
        ))}
      </ScrollCarousel>
    </section>
  );
}
